import { Input } from "antd";

const EnterCode = ({ len = 6, onFinish }) => {
  const onChange = (value) => {
    if (value.length === len) {
      onFinish(value);
    }
  };

  return <Input.OTP length={len} onChange={onChange} />;
};

export default EnterCode;
